export default "__VITE_ASSET__o2lEbCj9__"